import { Select } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card } from 'src/components/Card/Card';
import { MerchantSnapshotDto } from 'src/generated-api-client';
import { LoanApplicationMerchantSnapshotSalesTable } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationMerchantSnapshotSalesTable';
import { LoanApplicationSalesType } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore.types';

type LoanApplicationMerchantSnapshotSalesProps = {
    snapshot: MerchantSnapshotDto;
};

export const LoanApplicationMerchantSnapshotSales = observer(
    ({ snapshot }: LoanApplicationMerchantSnapshotSalesProps) => {
        const [filterType, setFilterType] = useState<LoanApplicationSalesType>(
            LoanApplicationSalesType.MONTHLY,
        );

        const sales = snapshot?.merchant?.sales || [];

        const filteredSales = useMemo(() => {
            return sales
                .filter(
                    (sale) =>
                        sale.type?.toLowerCase() === filterType.toLowerCase(),
                )
                .sort((a, b) => {
                    if (!a.periodStart || !b.periodStart) {
                        return 0;
                    }

                    return (
                        moment(b.periodStart).valueOf() -
                        moment(a.periodStart).valueOf()
                    );
                });
        }, [sales, filterType]);

        return (
            <Card
                title={t('LoanApplication.MerchantSnapshot.Sales.Title')}
                extra={
                    <Select
                        value={filterType}
                        onChange={(value) =>
                            setFilterType(value as LoanApplicationSalesType)
                        }
                        options={salesTypeOptions}
                    />
                }
            >
                <LoanApplicationMerchantSnapshotSalesTable
                    sales={filteredSales}
                />
            </Card>
        );
    },
);

const salesTypeOptions = [
    {
        value: LoanApplicationSalesType.MONTHLY,
        label: <Trans i18nKey="Merchant.Sales.Monthly" />,
    },
    {
        value: LoanApplicationSalesType.WEEKLY,
        label: <Trans i18nKey="Merchant.Sales.Weekly" />,
    },
];
